import { IconButton } from "@mui/material";
import { Edit, Visibility, Delete } from "@mui/icons-material";

export const getUsersColumns = (
  handleView: (user: any) => void,
  handleEdit: (user: any) => void,
  handleDelete: (user: any) => void
) => [
  {
    field: "_id",
    headerName: "ID",
    width: 100,
    editable: false,
  },
  {
    field: "name",
    headerName: "Name",
    width: 150,
    editable: true,
  },
  {
    field: "email",
    headerName: "Email",
    width: 200,
    editable: true,
  },
  {
    field: "phone",
    headerName: "Phone",
    width: 150,
    editable: true,
  },
  {
    field: "role",
    headerName: "Role",
    width: 100,
    editable: true,
  },
  {
    field: "hospital",
    headerName: "Hospital",
    width: 150,
    editable: true,
    valueGetter: (params: any) => {
      return params?.name || "N/A";
    },
  },
  {
    field: "actions",
    headerName: "Actions",
    width: 200,
    sortable: false,
    filterable: false,
    renderCell: (params: any) => (
      <>
        <IconButton
          color="primary"
          aria-label="view user"
          onClick={() => handleView(params.row)}
        >
          <Visibility />
        </IconButton>
        <IconButton
          color="secondary"
          aria-label="edit user"
          onClick={() => handleEdit(params.row)}
        >
          <Edit />
        </IconButton>
        <IconButton
          color="error"
          aria-label="delete user"
          onClick={() => handleDelete(params.row)}
        >
          <Delete />
        </IconButton>
      </>
    ),
  },
];
